import { useNavigate } from 'react-router-dom';

const ChangeStatusBtn = ({ itemId }) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/cats/merchant/assets/status/${itemId}`);
  };

  return (
    <button onClick={handleEdit}>
      Change Status
    </button>
  );
};

export default ChangeStatusBtn;
